import { fontSizes } from '../../../../constants/constants';
import dynamicfunction from '../../../../utils/dynamicfunction';
import { ErrorText, RadioButton, RowView, Text } from '../index';
import CustomInput from '../../../../components/CustomInput';
const ActiveNonFinancial = ({
  getContent,
  values,
  setFieldValue,
  setFieldTouched,
  touched,
  optionsYesOrNO,
  errors,
  isArabic,
}) => {
  const { TextWeight } = dynamicfunction();
  return (
    <>
      <div className='pt-3 sm:pt-5'>
        <Text
          text={getContent('if_active_non_financial')}
          size={fontSizes.h18}
          isTruncate={false}
          weight={TextWeight.medium}
          className='block'
          isRequired={true}
        />
      </div>
      {/* 1. Active NFE – Traded Corporation */}
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <RadioButton
          label={getContent('are_you_active_nfe')}
          value={values?.isActiveNfeRegularlyTradedCorporation}
          onChange={(e) => {
            setFieldValue('isActiveNfeRegularlyTradedCorporation', e);
            setFieldTouched('isActiveNfeRegularlyTradedCorporation', false);
          }}
          options={optionsYesOrNO}
          required={true}
        />
        <ErrorText
          text={getContent(touched?.isActiveNfeRegularlyTradedCorporation ? errors?.isActiveNfeRegularlyTradedCorporation : '')}
        />
      </RowView>
      {Number(values?.isActiveNfeRegularlyTradedCorporation) === 1 && (
        <RowView className='pt-3 gap-7 sm:pt-5' isResponsive>
          <CustomInput
            isRounded
            label={getContent('provide_the_name_of_securities')}
            value={values?.nameOfSecurityMarkets}
            onChange={(e) => {
              setFieldValue('nameOfSecurityMarkets', e.target.value);
              setFieldTouched('nameOfSecurityMarkets', true, false);
            }}
            isRequired={false}
            labelDivClass={"h-16 sm:h-6 md:h-14 lg:h-12 xl:h-9"}
            placeholder={getContent(
              'placeholder_tax_residence_country_or_jurisdiction'
            )}
            errorMessage={getContent(touched?.nameOfSecurityMarkets ? errors?.nameOfSecurityMarkets : '')}
          />
          <CustomInput
            isRounded
            label={getContent('name_of_active_nfe')}
            value={values?.nameOfActiveNfeRelatedEntityOfRegTradedCorp}
            onChange={(e) => {
              setFieldValue(
                'nameOfActiveNfeRelatedEntityOfRegTradedCorp',
                e.target.value
              );
              setFieldTouched('nameOfActiveNfeRelatedEntityOfRegTradedCorp', true, false);
            }}
            isRequired={false}
            labelDivClass={"h-20 sm:h-9 md:h-14 lg:h-12 xl:h-9"}
            placeholder={getContent('placeholder_number')}
            errorMessage={getContent(
              touched?.nameOfActiveNfeRelatedEntityOfRegTradedCorp ? errors?.nameOfActiveNfeRelatedEntityOfRegTradedCorp : ''
            )}
          />
        </RowView>
      )}

      {/* 4. Governmental Entity */}
      <RowView className='pt-3 gap-7 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('active_nfe_governmental_entity')}
            value={values?.activeNfeAGovernmentalEntity}
            onChange={(e) => {
              setFieldValue('activeNfeAGovernmentalEntity', e);
              setFieldTouched('activeNfeAGovernmentalEntity', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.activeNfeAGovernmentalEntity ? errors?.activeNfeAGovernmentalEntity : '')} />
        </div>
        <div className='w-full'>
          <RadioButton
            label={getContent('active_nfe_central_bank')}
            value={values?.activeNfeCentralBank}
            onChange={(e) => {
              setFieldValue('activeNfeCentralBank', e);
              setFieldTouched('activeNfeCentralBank', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText text={getContent(touched?.activeNfeCentralBank ? errors?.activeNfeCentralBank : '')} />
        </div>
        <div className='w-full'>
          <RadioButton
            label={getContent('active_nfe_international_organization')}
            value={values?.activeNfeAnInternationalOrganization}
            onChange={(e) => {
              setFieldValue('activeNfeAnInternationalOrganization', e);
              setFieldTouched('activeNfeAnInternationalOrganization', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.activeNfeAnInternationalOrganization ? errors?.activeNfeAnInternationalOrganization : '')}
          />
        </div>
      </RowView>

      {/* 7. Wholly Owned by Classified NFE */}
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <RadioButton
          label={getContent('is_wholly_owned_by_classified_nfe')}
          value={values?.isWhollyOwnedByClassifiedNFE}
          onChange={(e) => {
            setFieldValue('isWhollyOwnedByClassifiedNFE', e);
            setFieldTouched('isWhollyOwnedByClassifiedNFE', false);
          }}
          options={optionsYesOrNO}
          required={false}
        />
        <ErrorText text={getContent(touched?.isWhollyOwnedByClassifiedNFE ? errors?.isWhollyOwnedByClassifiedNFE : '')} />
      </RowView>

      {/* 8. Other Active NFE */}
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <RadioButton
          label={getContent('active_nfe_other_than_15')}
          value={values?.activeNfeOtherThan15Through17Above}
          onChange={(e) => {
            setFieldValue('activeNfeOtherThan15Through17Above', e);
            setFieldTouched('activeNfeOtherThan15Through17Above', false);

            if (Number(e) === 0) {
              setFieldValue('dateOfIncorporation', '');
              setFieldTouched('dateOfIncorporation', false);
              setFieldValue('dateOfOrganization', '');
              setFieldTouched('dateOfOrganization', false);
              setFieldValue('activeNFEOtherReason', '');
              setFieldTouched('activeNFEOtherReason', false);
            }
          }}
          options={optionsYesOrNO}
          required={false}
        />
        <ErrorText
          text={getContent(touched?.activeNfeOtherThan15Through17Above ? errors?.activeNfeOtherThan15Through17Above : '')}
        />
      </RowView>

      {Number(values?.activeNfeOtherThan15Through17Above) === 1 && (
        <>
          <div className='pt-3 sm:pt-5'>
            <CustomInput
              isRounded
              label={getContent('date_of_incorporation')}
              value={values?.dateOfIncorporation}
              onChange={(e) => {
                setFieldValue('dateOfIncorporation', e.target.value);
                setFieldTouched('dateOfIncorporation', true, false);
              }}
              type='date'
              isRequired={false}
              labelDivClass={"h-8 sm:h-6"}
              placeholder={getContent('placeholder_legal_name_entity_branch')}
              errorMessage={getContent(touched?.dateOfIncorporation ? errors?.dateOfIncorporation : '')}
            />
          </div>

          {/* 10. Active NFE by Reason of Income & Assets */}
          <RowView className='pt-3 gap-7 sm:pt-5' isResponsive>
            <div className='w-full'>
              <RadioButton
                label={getContent('active_nfe_reason_of_income')}
                value={values?.activeNfeReasonOfIncomeAndAssets}
                onChange={(e) => {
                  setFieldValue('activeNfeReasonOfIncomeAndAssets', e);
                  setFieldTouched('activeNfeReasonOfIncomeAndAssets', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText
                text={getContent(touched?.activeNfeReasonOfIncomeAndAssets ? errors?.activeNfeReasonOfIncomeAndAssets : '')}
              />
            </div>
            <div className='w-full'>
              <RadioButton
                label={getContent('holding_nfe_member_of_non_financial_group')}
                value={values?.holdingNfeMemberofNonFinancialGroup}
                onChange={(e) => {
                  setFieldValue('holdingNfeMemberofNonFinancialGroup', e);
                  setFieldTouched('holdingNfeMemberofNonFinancialGroup', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText
                text={getContent(touched?.holdingNfeMemberofNonFinancialGroup ? errors?.holdingNfeMemberofNonFinancialGroup : '')}
              />
            </div>
            <div className='lg:w-full hidden lg:block'></div>
          </RowView>

          {/* 12. Treasury Center NFE */}
          <RowView className='pt-3 gap-7 sm:pt-5' isResponsive>
            <div className='w-full'>
              <RadioButton
                label={getContent('treasury_center_nfe')}
                value={values?.treasuryCenterNfeMemberofNonFinancialGroup}
                onChange={(e) => {
                  setFieldValue('treasuryCenterNfeMemberofNonFinancialGroup', e);
                  setFieldTouched('treasuryCenterNfeMemberofNonFinancialGroup', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText
                text={getContent(
                  touched?.treasuryCenterNfeMemberofNonFinancialGroup ? errors?.treasuryCenterNfeMemberofNonFinancialGroup : ''
                )}
              />
            </div>
            <div className='w-full'>
              <RadioButton
                label={getContent('start_up_nfe')}
                value={values?.startupNfeDateOfOrg}
                onChange={(e) => {
                  setFieldValue('startupNfeDateOfOrg', e);
                  setFieldTouched('startupNfeDateOfOrg', false);

                  if (Number(e) === 0) {
                    setFieldValue('dateOfOrganization', '');
                    setFieldTouched('dateOfOrganization', false);
                  }
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText text={getContent(touched?.startupNfeDateOfOrg ? errors?.startupNfeDateOfOrg : '')} />
              {Number(values?.startupNfeDateOfOrg) === 1 && (
                <div className='pt-3 sm:pt-5'>
                  <CustomInput
                    isRounded
                    label={getContent('date_of_organization')}
                    value={values?.dateOfOrganization}
                    onChange={(e) => {
                      setFieldValue('dateOfOrganization', e.target.value);
                      setFieldTouched('dateOfOrganization', false, false);
                    }}
                    type='date'
                    isRequired={false}
                    placeholder={getContent('placeholder_legal_name_entity_branch')}
                    errorMessage={getContent(touched?.dateOfOrganization ? errors?.dateOfOrganization : '')}
                  />
                </div>
              )}
            </div>
            <div className='lg:w-full hidden lg:block'></div>
          </RowView>

          {/* 15. Non-profit NFE */}
          <RowView className='pt-3 gap-7 sm:pt-5' isResponsive>
            <div className='w-full'>
              <RadioButton
                label={getContent('nfe_liquidating_emerging_from_bankruptcy')}
                value={values?.nfeLiquidatingEmergingFromBankruptcy}
                onChange={(e) => {
                  setFieldValue('nfeLiquidatingEmergingFromBankruptcy', e);
                  setFieldTouched('nfeLiquidatingEmergingFromBankruptcy', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText
                text={getContent(touched?.nfeLiquidatingEmergingFromBankruptcy ? errors?.nfeLiquidatingEmergingFromBankruptcy : '')}
              />
            </div>
            <div className='w-full'>
              <RadioButton
                label={getContent('non_profit_nfe')}
                value={values?.nonProfitNfe}
                onChange={(e) => {
                  setFieldValue('nonProfitNfe', e);
                  setFieldTouched('nonProfitNfe', false);
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText text={getContent(touched?.nonProfitNfe ? errors?.nonProfitNfe : '')} />
            </div>
            <div className='lg:w-full hidden lg:block'></div>
          </RowView>

          <RowView className='pt-3 gap-7 sm:pt-5 flex-col' isResponsive>
            <div className='w-full'>
              <RadioButton
                label={getContent('other_please_provide_reason')}
                value={values?.otherProvideReasonForThisSelection}
                onChange={(e) => {
                  setFieldValue('otherProvideReasonForThisSelection', e);
                  setFieldTouched('otherProvideReasonForThisSelection', false);

                  if (Number(e) === 0) {
                    setFieldValue('activeNFEOtherReason', '');
                    setFieldTouched('activeNFEOtherReason', false);
                  }
                }}
                options={optionsYesOrNO}
                required={false}
              />
              <ErrorText
                text={getContent(touched?.otherProvideReasonForThisSelection ? errors?.otherProvideReasonForThisSelection : '')}
              />
              {Number(values?.otherProvideReasonForThisSelection) === 1 && (
                <div className={`w-full md:w-1/2 mt-2 ${isArabic ? "place-self-end" : "place-self-start"}`}>
                  <CustomInput
                    isRounded
                    label={getContent('provide_a_reason')}
                    value={values?.activeNFEOtherReason}
                    onChange={(e) => {
                      setFieldValue('activeNFEOtherReason', e.target.value);
                      setFieldTouched('activeNFEOtherReason', true, false);
                    }}
                    isRequired
                    placeholder={getContent('provide_a_reason')}
                    errorMessage={getContent(touched?.activeNFEOtherReason ? errors?.activeNFEOtherReason : '')}
                  />
                </div>
              )}
            </div>
          </RowView>
        </>
      )}
    </>
  );
};
export default ActiveNonFinancial;
